// Friendly, non-anatomical body outline with tappable areas (front and back views)
const FRONT = {
  head: <circle cx="100" cy="40" r="24" />,
  jaw: <ellipse cx="100" cy="64" rx="15" ry="7" />,
  throat: <rect x="90" y="74" width="20" height="16" rx="6" />,
  shoulders: <g><ellipse cx="66" cy="102" rx="17" ry="10" /><ellipse cx="134" cy="102" rx="17" ry="10" /></g>,
  chest: <ellipse cx="100" cy="128" rx="30" ry="20" />,
  stomach: <ellipse cx="100" cy="176" rx="27" ry="22" />,
  hands: <g><circle cx="36" cy="236" r="12" /><circle cx="164" cy="236" r="12" /></g>,
  legs: <g><rect x="72" y="256" width="24" height="140" rx="12" /><rect x="104" y="256" width="24" height="140" rx="12" /></g>,
};
const BACK = {
  head: <circle cx="100" cy="44" r="27" />,
  shoulders: <g><ellipse cx="66" cy="102" rx="17" ry="10" /><ellipse cx="134" cy="102" rx="17" ry="10" /></g>,
  back: <rect x="70" y="114" width="60" height="110" rx="24" />,
  hands: <g><circle cx="36" cy="236" r="12" /><circle cx="164" cy="236" r="12" /></g>,
  legs: <g><rect x="72" y="256" width="24" height="140" rx="12" /><rect x="104" y="256" width="24" height="140" rx="12" /></g>,
};
export const AREA_NAMES = { head: "Head", jaw: "Jaw", throat: "Throat", chest: "Chest", stomach: "Stomach", shoulders: "Shoulders", back: "Back", hands: "Hands", legs: "Legs" };

const Outline = () => (
  <g fill="var(--mm-surface-light, #EFEAF7)" stroke="var(--mm-border, #D9D1EA)" strokeWidth="1.5">
    <circle cx="100" cy="44" r="30" />
    <rect x="88" y="70" width="24" height="24" rx="8" />
    <rect x="58" y="90" width="84" height="160" rx="30" />
    <rect x="28" y="96" width="24" height="140" rx="12" transform="rotate(8 40 96)" />
    <rect x="148" y="96" width="24" height="140" rx="12" transform="rotate(-8 160 96)" />
    <rect x="70" y="240" width="28" height="160" rx="14" />
    <rect x="102" y="240" width="28" height="160" rx="14" />
  </g>
);

// fills: { area: { color, opacity } }. onTap(area) makes areas interactive.
export const BodyFigure = ({ side = "front", fills = {}, onTap, selected, testPrefix = "body" }) => {
  const areas = side === "front" ? FRONT : BACK;
  return (
    <svg viewBox="0 0 200 410" className="w-full max-w-[220px] mx-auto" role="img" aria-label={`Body outline, ${side}`} data-testid={`${testPrefix}-figure-${side}`}>
      <Outline />
      {Object.entries(areas).map(([a, shape]) => {
        const f = fills[a];
        return (
          <g key={a} onClick={onTap && (() => onTap(a))} role={onTap ? "button" : undefined} tabIndex={onTap ? 0 : undefined} aria-label={AREA_NAMES[a]}
            onKeyDown={onTap && ((e) => (e.key === "Enter" || e.key === " ") && onTap(a))}
            className={onTap ? "cursor-pointer focus:outline-none" : ""} data-testid={`${testPrefix}-area-${side}-${a}`}
            fill={f?.color || "transparent"} fillOpacity={f ? f.opacity : 1}
            stroke={selected === a ? "var(--mm-primary)" : onTap ? "rgba(124,92,191,.35)" : "none"} strokeWidth={selected === a ? 3 : 1.2} strokeDasharray={f || selected === a ? undefined : "4 4"}
            style={f ? { filter: `drop-shadow(0 0 6px ${f.color})`, transition: "fill-opacity .3s" } : undefined}>
            {shape}
          </g>
        );
      })}
    </svg>
  );
};
